module.exports = __webpack_public_path__ + "img/code.0fe42884.png";